import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.benutzer-identifier';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerIdentifierEffects {

    BenutzerIdentifier$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_BENUTZER_IDENTIFIER),
        mergeMap((x: ac.GetBenutzerIdentifierAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getBenutzerIdentifier().pipe(
                map((result: any) => {
                    return new ac.GetBenutzerIdentifierErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetBenutzerIdentifierFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungTemplatesService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungTemplatesService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungTemplatesService);
        }
        return this.service;
    }
}
